<template>
    <div>
        <WarningIconProp65Setup/>
        <div class="tabset tabs-desktop">
            <div class="tabset-controls">
                <div class="tabset-title-pdp-1">
                    <input type="radio" name="tabset" id="tab1" aria-controls="features" checked>
                    <label class="headline-l tabset-tab_title" for="tab1">Features</label>
                </div>
                <div class="tabset-title-pdp-2">
                    <input type="radio" name="tabset" id="tab2" aria-controls="description">
                    <label class="headline-l tabset-tab_title" for="tab2">Description</label>
                </div>
                <div class="tabset-title-pdp-3">
                    <input type="radio" name="tabset" id="tab3" aria-controls="specs">
                    <label class="headline-l tabset-tab_title" for="tab3">Specs</label>
                </div>
            </div>
            <div class="tabset-panels">
                <section id="features" class="tabset-panel">
                    <ul class="tabset-list tabset-list_features paragraph-feature">
                        <li class="paragraph-feature" v-for="(feature, index) in productFeatures" :key="index" :id="`feature-desktop-${index}`">
                            <span v-if="feature.includes(':')">{{ feature.split(':')[[0]] }}:</span>
                            {{ feature.includes(':') ? feature.split(":")[1] : feature }}</li>
                    </ul>
                    <div class="tabset-icons">
                        <template v-for="(featureIcon, featureIconIndex) in props.featureIcons" :key="featureIconIndex">
                            <div :id="`feature-icon-desktop-${featureIconIndex}`" class="tabset-icons-item" :style="{ width: `${100 / props.featureIcons.length}%` }">
                                <img :src="featureIcon.icon" alt="tabset-icon" />
                                <p class="headline-xs" v-html="featureIcon.text"></p>
                            </div>
                            <div class="tabset-vl" v-if="featureIconIndex < props.featureIcons.length-1"></div>
                        </template>
                    </div>
                    <div class="tabset-icons" v-if="prop65Spec.length > 0">
                        <div id="prop65_desktop" class="flex-row align-center prop65-desktop"><WarningIcon /><p class="paragraph-default"><strong>WARNING:</strong> California Residents&nbsp;<a @click.prevent="openProp65Modal()">click here</a> for California Prop 65 Warning.</p></div>
                    </div>
                </section>
                <section id="description" class="tabset-panel">
                    <p class="paragraph-feature" v-html="formattedDescription">
                    </p>
                </section>
                <section id="specs" class="tabset-panel tabset-spec">
                    <div class="tabset-spec_container">
                        <div class="tabset-specs">
                            <div class="tabset-icon_links">
                                <div id="spec_sheet_desktop" class="tabset-icon_links-item" v-if="props.spec_sheet">
                                    <SpecSheetIcon alt="spec-icon" />
                                    <span aria-label="Spec Sheet">
                                        <a class="navigation" @click="openSpecSheetModal()">Spec Sheet</a>
                                    </span>
                                </div>
                                <div id="care_instructions_desktop" class="tabset-icon_links-item" v-if="careInstructions">
                                    <CareIcon class="spec-icon" />
                                    <span aria-label="Care Instructions" v-html="careInstructions.data"></span>
                                </div>
                                <div id="shipping_dimensions_desktop" class="tabset-icon_links-item" v-if="props.shipping_dimensions">
                                    <ShippingIcon alt="spec-icon" />
                                    <span aria-label="Shipping Dimensions">
                                        <a class="navigation" @click="openShippingDimensions()">Shipping Dimensions</a>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <table class="paragraph-feature specs-table">
                            <tr v-for="(spec, index) in props.specs" :key="index">
                                <th :id="`specs-row-header-desktop-${index}`">{{ spec.header }}</th>
                                <td v-if="spec.type == 'text'">{{ spec.data }}</td>
                                <td v-else v-html="spec.data"></td>
                            </tr>
                        </table>
                    </div>
                </section>
            </div>
        </div>
        <div class="tabs-mobile">
            <section class="accordion-container">
                <details class="tab accordion" open>
                    <summary class="label-container accordion__title" role="button">
                        <div class="tab__label">
                            <label for="cb1" class="headline-xs text-rothcoBlack">Features</label>
                        </div>
                    </summary>
                    <div class="tab__content tab__features accordion__content">
                            <ul class="tabset-list tabset-list_features">
                                <li v-for="(feature, index) in productFeatures" :key="index" :id="`feature-mobile-${index}`">
                                    <span v-if="feature.includes(':')">{{ feature.split(":")[0] }}:</span>
                                    {{ feature.includes(':') ? feature.split(":")[1] : feature }}</li>
                            </ul>
                            <div id="prop65_mobile" v-if="prop65Spec.length > 0" class="flex-row align-center"><WarningIcon /><p class="paragraph-default"><strong>WARNING:</strong> California Residents&nbsp;<a @click.prevent="openProp65Modal()">click here</a> for California Prop 65 Warning.</p></div>
                            <div class="tabset-icons">
                                <div :id="`feature-icon-mobile-${featureIconIndex}`" class="tabset-icons-item" :style="{ width: `${100 / featureIcons.length}%` }" v-for="(featureIcon, featureIconIndex) in props.featureIcons" :key="featureIconIndex">
                                    <img :src="featureIcon.icon" alt="tabset-icon" />
                                    <p class="headline-xs" v-html="featureIcon.text"></p>
                                </div>
                            </div>
                    </div>
                </details>
                <details class="tab accordion">
                    <summary class="tab__label accordion__title">
                        <label for="cb2" class="headline-xs text-rothcoBlack">Description</label>
                    </summary>
                    <div class="tab__content accordion__content">
                        <p class="paragraph-feature" v-html="formattedDescription">
                        </p>
                    </div>
                </details>
                <details class="tab accordion">
                    <summary class="tab__label tab__last-child accordion__title">
                        <label for="cb3" class="headline-xs text-rothcoBlack">Specs</label>
                    </summary>
                    <div class="tab__content accordion__content">
                            <div class="tabset-specs">
                                <div class="tabset-icon_links">
                                    <div id="spec_sheet_mobile" class="tabset-icon_links-item" v-if="props.spec_sheet">
                                        <SpecSheetIcon alt="spec-icon" />
                                        <span aria-label="Spec Sheet">
                                            <a class="navigation" @click="openSpecSheetModal()">Spec Sheet</a>
                                        </span>
                                    </div>
                                    <div id="care_instructions_mobile" class="tabset-icon_links-item" v-if="careInstructions">
                                        <CareIcon class="spec-icon" />
                                        <span aria-label="Care Instructions" v-html="careInstructions.data"></span>
                                    </div>
                                    <div id="shipping_dimensions_mobile" class="tabset-icon_links-item" v-if="props.shipping_dimensions">
                                        <ShippingIcon alt="spec-icon" />
                                        <span aria-label="Shipping Dimensions">
                                            <a class="navigation" @click="openShippingDimensions()">Shipping Dimensions</a>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="tabset-spec_container">
                                <table class="paragraph-feature specs-table">
                                    <tr v-for="(spec, index) in props.specs" :key="index">
                                        <th :id="`specs-row-header-mobile-${index}`">{{ spec.header }}</th>
                                        <td v-if="spec.type == 'text'">{{ spec.data}}</td>
                                        <td v-else v-html="spec.data"></td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                </details>
            </section>
        </div>
    </div>
</template>
<script lang="ts" setup>
    import { computed } from "vue";
    import { useDialog } from "primevue/usedialog";
    import ShippingDimensionsModal from "@/components/ShippingDimensionsModal.vue";
    import SpecSheetModal from "@/components/SpecSheetModal.vue";
    import Prop65WarningModal from "@/components/Prop65WarningModal.vue";
    import WarningIcon from "@icons/warning-icon.svg";
    import WarningIconProp65Setup from "@icons/warning-icon-setup.svg";
    import SpecSheetIcon from  "@icons/spec-sheet-icon.svg";
    import CareIcon from "@icons/care-icon.svg";
    import ShippingIcon from "@icons/shipping-icon.svg";
    import he from "he";
    const dialog = useDialog();
    let props = defineProps({
        features: {
            type: Array<String>,
            default: []
        },
        featureIcons: {
            type: Array<Object>,
            default(){
                return [];
            }
        },
        description: {
            type: String,
            default: ""
        },
        specs: {
            type: Array<Object>,
            default(){
                return [];
            }
        },
        spec_groups: {
            type: Array<String>,
            default: []
        },
        shipping_dimensions: {
            type: Array<Object>,
            default(){
                return [];
            }
        },
        spec_sheet: {
            type: String,
            default: ''
        },
        prop65Spec: {
            type: Array<Object>,
            default(){
                return []
            }
        }
    });

    let productFeatures = computed(()=>{
        return props.features.map((feature) => {
            return he.decode(feature);
        })
    });
    let formattedDescription = computed(()=>{
        let description = props.description;

        if ((description?.startsWith('"') && description?.endsWith('"')) || (description?.startsWith("'") && description?.endsWith("'"))) {
            description = description?.slice(1, -1);
        }

        return he.decode(description
            .replace(/''/g, "'")
            .replace(/""/g, '"')
            .replace(/\\'/g, "'")
            .replace(/\\"/g, '"')
            .replace(/\\n/g, '<br>'));
    });

    let careInstructions = computed(()=>{
        let careSpec = JSON.parse(JSON.stringify(props.specs.find(spec=>spec.header == 'Care Inst.') ?? null));
        if(careSpec){
            careSpec.data = careSpec.data.replace(/<a\b(?![^>]*\bclass=)([^>]*)>/g, '<a class="navigation"$1>');
        }
        return careSpec;
    });

    let openShippingDimensions = () => {
        dialog.open(ShippingDimensionsModal, {
            props: {
                showHeader: false,
                modal: true,
            },
            data: {
                shipping_dimensions: props.shipping_dimensions,
                spec_groups: props.spec_groups
            },
        });
    };

    let openSpecSheetModal = () => {
        dialog.open(SpecSheetModal, {
            props: {
                showHeader: false,
                modal: true
            },
            data: {
                spec_sheet: props.spec_sheet
            }
        });
    };
    function openProp65Modal(){
        dialog.open(Prop65WarningModal, {
            props: {
                showHeader: false,
                modal: true
            },
            data: {
                prop65Spec: props.prop65Spec.map(spec => spec.value.spec_value)
            }
        });
    }
</script>
